import { Outlet } from 'react-router-dom';

// ==============================|| SETTINGS LAYOUT ||============================== //

const SettingsLayout = () => (
  <>
    <Outlet />
  </>
);

export default SettingsLayout;
